import * as Yup from 'yup'
export const validationSchema = Yup.object().shape({
    invoice_number: Yup.string().nullable(),
    vat_number:Yup.string().nullable(),
    fee:Yup.string().nullable().min(0,'Minimal value is 0 !').typeError('Fee must be a number !'),
    comment:Yup.string().nullable(),
    supplier_id:Yup.number().required('Supplier must be choosen !'),
    currency_id:Yup.number().required('Currency must be choosen !')    
  })